import React, { useLayoutEffect } from 'react';

import Hero from '../components/home/Hero';
import RoomsAndSuites from '../components/home/RoomsAndSuites';
import VideoSection from '../components/home/VideoSection';
import FacilitiesSection from '../components/home/FacilitiesSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import HotelAmenitiesSection from '../components/home/HotelAmenitiesSection';
import ScrollToHeroButton from '../components/ui/ScrollToHeroButton';
import PineridgeAboutSection from '../components/home/PineridgeAboutSection';

const HomePage = () => {
  const aboutSectionId = "about-section";

  useLayoutEffect(() => {
    const header = document.getElementById('header');
    if (!header) return;

    const handleScroll = () => {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Hero id="hero" targetId={aboutSectionId} />
      <div id={aboutSectionId}>
        <PineridgeAboutSection />
      </div>
      <div className="divider"></div>
      <div id="rooms-and-suites-section">
        <RoomsAndSuites />
      </div>
      <div className="divider"></div>
      <VideoSection />
      <div className="divider"></div>
      <FacilitiesSection />
      <div className="divider"></div>
      <TestimonialsSection />
      <div className="divider"></div>
      <HotelAmenitiesSection />
      <ScrollToHeroButton />
    </>
  );
};

export default HomePage;
